// Three.js Centralized Configuration
// Ensures consistent THREE import and access across all modules
// Prevents minification naming conflicts between chunks

import * as THREE from 'three';

// Geometries
export const ShipGeometry = new THREE.ConeGeometry(5, 20, 8);
ShipGeometry.rotateX(Math.PI / 2);

export const EnemyFighterGeometry = new THREE.ConeGeometry(3, 10, 8);
EnemyFighterGeometry.rotateX(Math.PI / 2);

export const EnemyBomberGeometry = new THREE.BoxGeometry(8, 8, 8);

export const EnemyBossGeometry = size => new THREE.DodecahedronGeometry(size, 1);

export const PowerUpGeometry = new THREE.OctahedronGeometry(3, 0);

export const ProjectileGeometry = new THREE.SphereGeometry(1, 8, 8);

export const StarGeometry = new THREE.BufferGeometry();

export const SkyboxGeometry = new THREE.SphereGeometry(5000, 32, 32);

// Materials
export const PlayerMaterial = color => new THREE.MeshPhongMaterial({
  color,
  emissive: color,
  emissiveIntensity: 0.3,
  shininess: 100,
});

export const EnemyMaterial = color => new THREE.MeshPhongMaterial({
  color,
  emissive: 0x330000,
  shininess: 50,
});

export const PowerUpMaterial = color => new THREE.MeshPhongMaterial({
  color,
  emissive: color,
  emissiveIntensity: 0.5,
  shininess: 100,
  transparent: true,
  opacity: 0.9,
});

export const ProjectileMaterial = color => new THREE.MeshBasicMaterial({
  color,
});

export const StarMaterial = new THREE.PointsMaterial({
  size: 2,
  vertexColors: true,
  transparent: true,
  opacity: 0.8,
  sizeAttenuation: true,
});

export const SkyboxMaterial = canvasTexture => new THREE.MeshBasicMaterial({
  map: canvasTexture,
  side: THREE.BackSide,
});

// Constants
export const COLORS = {
  HONEY_BADGER: 0xff6600,
  OCTOPUS: 0xffffff,
  ELEPHANT: 0x333333,
  MANTIS_SHRIMP: 0xff00ff,
  ANT: 0x00aa00,
  ENEMY_FIGHTER: 0xff0000,
  ENEMY_BOMBER: 0xff6600,
  ENEMY_BOSS: 0xff00ff,
  POWERUP_LASER: 0xff0000,
  POWERUP_SHIELD: 0x00ff00,
  POWERUP_BOMB: 0xff6600,
  POWERUP_LIFE: 0x00ffff,
  POWERUP_BOOST: 0xffff00,
};

// Re-export THREE for consistent access
export { THREE };

export default {
  THREE,
  ShipGeometry,
  EnemyFighterGeometry,
  EnemyBomberGeometry,
  EnemyBossGeometry,
  PowerUpGeometry,
  ProjectileGeometry,
  StarGeometry,
  SkyboxGeometry,
  PlayerMaterial,
  EnemyMaterial,
  PowerUpMaterial,
  ProjectileMaterial,
  StarMaterial,
  SkyboxMaterial,
  COLORS,
};
